// Workstream: Accounts (sign in, my packs, game history).
// Add this workstream's pages here; main.tsx renders every entry.
import type { AppRoute } from '../../routes';
import { AccountPage } from './AccountPage';

export const routes: AppRoute[] = [{ path: '/account', element: <AccountPage /> }];
